module.exports = __webpack_public_path__ + "img/page-jigyo-top-old-cars.4b8ed190.jpg";